"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHostLocal = isHostLocal;
exports.createFullyQualifiedUrl = createFullyQualifiedUrl;
const app_1 = require("@aurora/shared-types/app");
const UrlBuilder_1 = __importDefault(require("@aurora/shared-utils/helpers/urls/UrlHelper/UrlBuilder"));
/**
 * Returns true if the provided window location host contains localhost
 *
 * @param host https://developer.mozilla.org/en-US/docs/Web/API/Location/host
 */
function isHostLocal(host) {
    var _a;
    const port = (_a = UrlBuilder_1.default.fromUrl(host).uri.port()) === null || _a === void 0 ? void 0 : _a.toString();
    return port == '3000' || port == '3001' || host.includes('localhost');
}
/**
 * Creates a full qualified url to allow routing between the admin and enduser applications
 * Handles local development, qa/dev communities, and prod communities
 *
 * @param host the window location host
 * @param relativeUrl the relativeUrl from NextJS
 * @param targetApp the target application
 */
function createFullyQualifiedUrl(host, relativeUrl, targetApp) {
    if (isHostLocal(host)) {
        // swap port number for local development
        const port = targetApp === app_1.AppType.END_USER ? '3000' : '3001';
        return `//${UrlBuilder_1.default.fromUrl(host).uri.hostname()}:${port}${relativeUrl}`;
    }
    // on prod sites, where the domain is the same, simply return the relativeUrl
    return relativeUrl;
}
//# sourceMappingURL=CrossApplicationRouterHelper.js.map